import { graphql } from "@/data-access/graphql";
import { ShareVoiceMetricsTableFragment } from "../fragments/shareOfVoice-table-fragments";

export const GetShareOfVoiceMetricsTableData = graphql(
  `
    query getShareOfVoiceMetricsTableData($projectionFilters: FeedArticleProjectionFilter!) {
      shareVoiceTable(projectionFilters: $projectionFilters) {
        ...ShareVoiceTableFragment
      }
    }
  `,
  [ShareVoiceMetricsTableFragment],
);

/**
 * Mutation to export SOV table data as CSV. Returns a presigned S3 download URL
 * or OperationInfo on error.
 */
export const ExportShareVoiceTableCsv = graphql(`
  mutation ExportShareVoiceTableCsv($filters: FeedArticleProjectionFilter!) {
    exportShareVoiceTableCsv(filters: $filters) {
      ... on CSVExportResponse {
        __typename
        url
      }
      ... on OperationInfo {
        __typename
        messages {
          code
          field
          kind
          message
        }
      }
    }
  }
`);
